import { replaceTokensWithComponents } from '@cat-ecom/common/utils/stringUtils';

export const ENROLLED_CAT_VANTAGE_REWARDS_STAR =
  'https://s7d2.scene7.com/is/content/Caterpillar/CM20231214-7f82d-8062b';
export const NOT_ENROLLED_CAT_VANTAGE_REWARDS_STAR =
  'https://s7d2.scene7.com/is/content/Caterpillar/CM20231214-01efc-d1700';

export const CAT_VANTAGE_REWARDS_STAR = {
  size: 32,
  description: 'Cat Vantage Rewards Star'
};
export const tradeMarkSymbol = '®';
const superscriptOfRegisteredTrademarkSymbol = <sup>®</sup>;
export const catVantageRewardCopyright = replaceTokensWithComponents(
  ' Cat{0} Vantage Rewards ',
  superscriptOfRegisteredTrademarkSymbol
);
